import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import './App.css';
import Menu from './menu';
import theme from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Menu />
      </div>
    </ThemeProvider>
  );
}

export default App;
